import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import routes from "../../libs/routes";
// import consts from '../../libs/consts';

import { logIn, logOut } from "../../redux/usersSlice";
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";

import * as API from "../../libs/service";

import Popup01 from "../popup/Popup01"

export default function PopupProfileEdit(props) {
    const {
        title,
        subTitle,
        text,
        lefttext,
        width,
        button,
        buttonCancel,
        func,
        setFunc,
        noneLoading,
        top,
        cancelFunc,
        x_btn,
        cancelText,
        longButton,
        max_width,
        popType
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const lang = useSelector(state => state.langReducer.lang);
    console.log("lang : ", lang);
    const { mbData } = useSelector((s) => s.usersReducer);

    const [maxWidthCut, setMaxWidthCut] = useState(max_width);

    const [nameTitleView, setNameTitleView] = useState(false);
    const [nameValue, setNameValue] = useState('');
    const [nameAster, setNameAster] = useState(true);
    const [nameErr, setNameErr] = useState(0);

    const [pwSuc, setPwSuc] = useState(false);

    const [pwNowTitleView, setPwNowTitleView] = useState(false);
    const [pwNowview, setPwNowview] = useState(false);
    const [pwNowValue, setPwNowValue] = useState('');
    const [pwNowAster, setPwNowAster] = useState(true);
    const [pwNowErr, setPwNowErr] = useState(0);

    const [pwTitleView, setPwTitleView] = useState(false);
    const [pwview, setPwview] = useState(false);
    const [pwValue, setPwValue] = useState('');
    const [pwAster, setPwAster] = useState(true);

    const [pwChkTitleView, setPwChkTitleView] = useState(false);
    const [pwChkview, setPwChkview] = useState(false);
    const [pwChkValue, setPwChkValue] = useState('');
    const [pwChkAster, setPwChkAster] = useState(true);
    const [pwErr, setPwErr] = useState(0);
    const [pwChkErr, setPwChkErr] = useState(0);

    useEffect(() => {
        if (!buttonCancel && !button && top) {
            const popup = document.querySelector(".popup.show");
            /* console.log(popup); */
            if (popup) popup.classList.add("popup_top");
            const timeout = setTimeout(() => {
                dispatch(close());
            }, 1000);
            popup.addEventListener("click", () => {
                dispatch(close());
                clearTimeout(timeout);
            });
        }
    }, []);

    const setFunction = () => {
        if (setFunc) setFunc();
        dispatch(close());
    };

    const ProfileEditFunc = async (type) => {
        let sender = {
            id: mbData?.idx,
            email: mbData?.mb_email,
            type: type
        };

        if (type === "password") {
            sender.now_password = pwNowValue;
            sender.password = pwValue;
        }

        if (type === "name") {
            sender.name = nameValue;
        }

        /* console.log(sender); */

        dispatch(loadingStart());

        await API.patch('user', sender, true).then(({ data }) => {
            console.log('체크', data);

            if (data?.msg === 'edit_password_err') {
                setPwNowErr(2)
                dispatch(loadingEnd());
                return;
            } else {
                console.log("data : ", data);
                dispatch(
                    logIn({
                        mbData: {
                            idx: mbData?.idx,
                            mb_type: data?.validType,
                            mb_email: data?.email,
                            mb_name: data?.fullname,
                            pwCount: popType === "password" ? pwValue?.length : mbData?.pwCount,
                            lang: mbData?.language === 'ko' ? 0 : 1,
                            isAcceptMarketingActivities: mbData?.isAcceptMarketingActivities,
                            emailLanguage: data?.emailLanguage,
                            countryCode: data?.countryCode
                        },
                        // autoLogin: moment(),
                    })
                );

                dispatch(open({
                    component:
                        <Popup01
                            x_btn={true}
                            text1={lang === 0 ? '변경이 완료되었습니다.' : 'Change successful.'}
                            longButton={lang === 0 ? '확인' : 'OK'}
                        />
                }));
            }

        }).catch(err => {
            console.log(err.response.data);
            dispatch(open({
                component:
                    <Popup01
                        x_btn={true}
                        text1={lang === 0 ? '비밀번호가 틀렸습니다.' : 'The password is incorrect.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                        setFunc={() => {
                            // navigate(routes.main)
                        }}
                    />
            }));
        }).finally(() => {
            setTimeout(() => {
                dispatch(loadingEnd());
            }, 500);
        })
    }

    const InputChange = (event) => {
        const { name, value } = event.target;

        if (name === "name") {
            setNameValue(value)

            if (value) {
                let NameChk = /^[가-힣a-zA-Z]*$/;
                setNameAster(false);
                setNameTitleView(true)

                if (!NameChk.test(value)) {
                    setNameErr(1);
                    return;
                } else {
                    setNameErr(0);
                }
            } else {
                setNameAster(true);
                setNameTitleView(false)
            }
        }

        if (name === "now_password") {
            let pwChk = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,15}$/;
            setPwNowValue(value)

            if (value) {
                setPwNowAster(false);
                setPwNowTitleView(true)
            } else {
                setPwNowAster(true);
                setPwNowTitleView(false)
            }

            if (!pwChk.test(value)) {
                setPwNowErr(1)
            } else {
                setPwNowErr(0)
            }

        }

        if (name === "login_password") {
            let pwChk = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,15}$/;
            setPwValue(value)

            if (value) {
                setPwAster(false);
                setPwTitleView(true)
            } else {
                setPwAster(true);
                setPwTitleView(false)
            }

            if (pwChkValue !== value) {
                setPwChkErr(1)
                setPwSuc(false)
            } else {
                setPwChkErr(0)
                setPwSuc(true)
            }

            if (!pwChk.test(value)) {
                setPwErr(1)
            } else {
                setPwErr(0)
            }

            if (pwChkValue === value && pwChk.test(value)) {
                setPwSuc(true);
            }
        }

        if (name === "login_password_chk") {
            let pwChk = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,15}$/;
            setPwChkValue(value)

            if (value) {
                setPwChkAster(false);
                setPwChkTitleView(true)
            } else {
                setPwChkAster(true);
                setPwChkTitleView(false)
            }

            if (pwValue !== value) {
                setPwChkErr(1)
                setPwSuc(false)
            } else {
                setPwChkErr(0)
            }

            if (!pwChk.test(value)) {
                setPwErr(1)
                setPwSuc(false)
            } else {
                setPwErr(0)
            }

            if (pwValue === value && pwChk.test(value)) {
                setPwSuc(true);
            }
        }
    }

    return (
        <>
            <div
                className={"popup_default01"}
                style={{
                    maxWidth: max_width ? maxWidthCut : '400px',
                    width: '100%',
                    marginLeft: 10,
                    marginRight: 10,
                }}
            >
                {x_btn &&
                    <div
                        className="popup_x_btn_box"
                        style={{

                        }}
                    >
                        <img src={require("../../assets/images/exit-icon.svg").default}
                            className="popup_x_btn"
                            onClick={() => {
                                dispatch(close());
                            }}
                            style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                        />
                        <div style={{ height: 16 }} />
                    </div>
                }
                <div
                    className={`popup_content_box profile`}
                    style={{

                    }}
                >
                    <div className="title_box">
                        {popType == 'password' &&
                            <>
                                <p>{lang === 0 ? '비밀번호 변경' : 'Change Password'}</p>
                                <span>{lang === 0 ? '비밀번호(8~15자리 영문,숫자,특수문자 혼합)' : 'Password (8-15 characters: letters, numbers, and special characters)'}</span>
                            </>
                        }

                        {popType == 'name' &&
                            <>
                                <p>{lang === 0 ? '이름 입력' : 'Enter Name'}</p>
                                <span>{lang === 0 ? '3~10자리 이상 문자를 입력하세요.' : 'Enter 3 to 10 characters.'}</span>
                            </>
                        }

                    </div>

                    <div className="input_box">
                        {popType === "password" &&
                            <>
                                <div
                                    className="input_div pw_div"
                                    style={{
                                        border: pwNowTitleView ? '1px solid #0E6AF4' : ''
                                    }}
                                >
                                    {pwNowTitleView &&
                                        <div className="input_focus pw_focus">
                                            <p>{lang === 0 ? '현재 비밀번호' : 'Current Password'}</p>
                                            <span
                                                className="input_aster"
                                                style={{
                                                    top: '-2px'
                                                }}
                                            >
                                                *
                                            </span>
                                        </div>
                                    }
                                    <input
                                        type={!pwNowview ? "password" : "text"}
                                        placeholder={lang === 0 ? "현재 비밀번호" : "Current Password"}
                                        className="input_pw"
                                        name="now_password"
                                        value={pwNowValue}
                                        onChange={InputChange}
                                        onBlur={() => {
                                            setPwNowTitleView(false)
                                        }}
                                        maxLength={15}
                                    />
                                    {!pwNowview ?
                                        <img
                                            src={require("../../assets/icon/eye_off.svg").default}
                                            onClick={() => {
                                                setPwNowview(true)
                                            }}
                                        />
                                        :
                                        <img
                                            src={require("../../assets/icon/eye_on.svg").default}
                                            onClick={() => {
                                                setPwNowview(false)
                                            }}
                                        />
                                    }
                                    {pwNowAster &&
                                        <span
                                            className="input_aster"
                                            style={{
                                                left: lang === 0 ? '108px' : '152px',
                                                top: pwNowTitleView ? '20px' : '15px'
                                            }}
                                        >
                                            *
                                        </span>
                                    }
                                </div>
                                {/* {pwNowErr == 1 && <span className="err_msg id">비밀번호 형식이 올바르지 않습니다.</span>} */}
                                {pwNowErr == 2 && <span className="err_msg id">{lang === 0 ? '비밀번호가 일치하지 않습니다.' : 'Passwords do not match.'}</span>}

                                <div
                                    className="input_div pw_div"
                                    style={{
                                        border: pwTitleView ? '1px solid #0E6AF4' : ''
                                    }}
                                >
                                    {pwTitleView &&
                                        <div className="input_focus pw_focus">
                                            <p>{lang === 0 ? '변경할 비밀번호' : 'New Password'}</p>
                                            <span
                                                className="input_aster"
                                                style={{
                                                    left: lang === 0 ? '76px' : '102px',
                                                    top: '-2px'
                                                }}
                                            >
                                                *
                                            </span>
                                        </div>
                                    }
                                    <input
                                        type={!pwview ? "password" : "text"}
                                        placeholder={lang === 0 ? "변경할 비밀번호" : "New Password"}
                                        className="input_pw"
                                        name="login_password"
                                        value={pwValue}
                                        onChange={InputChange}
                                        onBlur={() => {
                                            setPwTitleView(false)
                                        }}
                                        maxLength={15}
                                    />
                                    {!pwview ?
                                        <img
                                            src={require("../../assets/icon/eye_off.svg").default}
                                            onClick={() => {
                                                setPwview(true)
                                            }}
                                        />
                                        :
                                        <img
                                            src={require("../../assets/icon/eye_on.svg").default}
                                            onClick={() => {
                                                setPwview(false)
                                            }}
                                        />
                                    }
                                    {pwAster &&
                                        <span
                                            className="input_aster"
                                            style={{
                                                left: lang === 0 ? '122px' : '132px',
                                                top: pwTitleView ? '20px' : '15px'
                                            }}
                                        >
                                            *
                                        </span>
                                    }
                                </div>

                                <div
                                    className="input_div pw_div"
                                    style={{
                                        border: pwChkTitleView ? '1px solid #0E6AF4' : ''
                                    }}
                                >
                                    {pwChkTitleView &&
                                        <div className="input_focus pw_focus">
                                            <p>{lang === 0 ? '변경할 비밀번호 재입력' : 'Confirm New Password'}</p>
                                            <span
                                                className="input_aster"
                                                style={{
                                                    left: '110px',
                                                    top: '-2px'
                                                }}
                                            >
                                                *
                                            </span>
                                        </div>
                                    }
                                    <input
                                        type={!pwChkview ? "password" : "text"}
                                        placeholder={lang === 0 ? "변경할 비밀번호 재입력" : "Confirm New Password"}
                                        className="input_pw"
                                        name="login_password_chk"
                                        value={pwChkValue}
                                        onChange={InputChange}
                                        onBlur={() => {
                                            setPwChkTitleView(false)
                                        }}
                                        maxLength={15}
                                    />
                                    {!pwChkview ?
                                        <img
                                            src={require("../../assets/icon/eye_off.svg").default}
                                            onClick={() => {
                                                setPwChkview(true)
                                            }}
                                        />
                                        :
                                        <img
                                            src={require("../../assets/icon/eye_on.svg").default}
                                            onClick={() => {
                                                setPwChkview(false)
                                            }}
                                        />
                                    }
                                    {pwChkAster &&
                                        <span
                                            className="input_aster"
                                            style={{
                                                left: lang === 0 ? '168px' : '192px',
                                                top: pwChkTitleView ? '20px' : '15px'
                                            }}
                                        >
                                            *
                                        </span>
                                    }
                                </div>
                                {pwChkErr == 1 && <span className="err_msg id">{lang === 0 ? '비밀번호가 일치하지 않습니다.' : 'Passwords do not match.'}</span>}
                                {pwErr == 1 && <span className="err_msg id">{lang === 0 ? '비밀번호 형식이 올바르지 않습니다.' : 'Invalid password format.'}</span>}
                            </>
                        }

                        {popType === "name" &&
                            <>
                                <div
                                    className="input_div pw_div"
                                    style={{
                                        border: nameTitleView ? '1px solid #0E6AF4' : ''
                                    }}
                                >
                                    {nameTitleView &&
                                        <div className="input_focus pw_focus">
                                            <p>{lang === 0 ? '이름' : 'Name'}</p>
                                        </div>
                                    }
                                    <input
                                        type="text"
                                        placeholder={lang === 0 ? "이름 입력" : "Enter Name"}
                                        className="input_pw"
                                        name="name"
                                        value={nameValue}
                                        onChange={InputChange}
                                        onBlur={() => {
                                            setNameTitleView(false)
                                        }}
                                        maxLength={10}
                                    />
                                </div>
                                {nameErr == 1 && <span className="err_msg id">{lang === 0 ? '이름이 올바르지 않습니다.' : 'Invalid name.'}</span>}
                            </>
                        }
                    </div>

                    {(buttonCancel || button || longButton) &&
                        <div
                            className="popup_btn_box"
                            style={{ width: '100%' }}
                        >

                            {buttonCancel && (
                                <button
                                    className="button_cancel"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            setFunction();
                                        } else {
                                            if (cancelFunc) cancelFunc();
                                            dispatch(close());
                                        }
                                    }}
                                >
                                    {buttonCancel}
                                </button>
                            )}
                            {button && (
                                <button
                                    className="button_success"
                                    onClick={() => {
                                        if (pwSuc) {
                                            ProfileEditFunc("password")
                                        }
                                        if (popType === "name") {
                                            ProfileEditFunc("name")
                                        }
                                    }}
                                >
                                    {button}
                                </button>
                            )}
                            {longButton && (
                                <button
                                    className="button_success long"
                                    onClick={() => {

                                    }}
                                >
                                    {longButton}
                                </button>
                            )}
                        </div>
                    }
                </div>
            </div>
        </>
    );
}